import colors from "exports.module.scss";
import { useEffect, useState } from "react";

import SenecaSpinner from "features/common/spinners/seneca-spinner/SenecaSpinner";

import { DELAY_BEFORE_LOADING_STATE } from "./consts";
import "./SpinnerLoadingScreen.scss";

type Props = {
  color?: "white" | "dark";
};

export default function SpinnerLoadingScreen({ color = "white" }: Props) {
  const [showLoading, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(true);
    }, DELAY_BEFORE_LOADING_STATE);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return showLoading ? (
    <div className="SpinnerLoadingScreen">
      <SenecaSpinner
        className="SpinnerLoadingScreen__spinner"
        style={{ color: color === "white" ? "white" : colors.dustyGray }}
      />
    </div>
  ) : null;
}
